import videojs from "video.js";

const Button = videojs.getComponent("Button");

// In seconds:
const skipAmount = 30;

/**
 * The base class for buttons
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class SkipBackButton
 */
class SkipBackButton extends Button
{
	/**
	 * Creates an instance of this class.
	 *
	 * @param {Player} player
	 *		The `Player` that this class should be attached to.
	 *
	 * @param {Object} [options={}]
	 *		The key/value store of player options.
	 */
	constructor(player, options = {})
	{
		super(player, options);
		this.player = player;

		this.controlText(this.localize(this.controlText_, [skipAmount]));

		this.player.on("seekingdisabled", this.hide.bind(this));
		this.player.on("seekingenabled", this.show.bind(this));
	}

	/**
	 * Builds the default DOM `className`.
	 *
	 * @return {string}
	 *		The DOM `className` for this object.
	 */
	buildCSSClass()
	{
		return `vjs-skip-back-button ${super.buildCSSClass()}`;
	}

	/**
	 * This gets called when an `SkipBackButton` is "clicked". See
	 * {@link ClickableComponent} for more detailed information on what a click can be.
	 *
	 * @listens tap
	 * @listens click
	 */
	handleClick()
	{
		const seekTarget = this.player.currentTime() - skipAmount;
		this.player.currentTime(Math.max(seekTarget, 0));
	}
}

/**
 * The text that should display over the `SkipBackButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */
SkipBackButton.prototype.controlText_ = "Seek Back {1} seconds";

videojs.registerComponent("skipBackButton", SkipBackButton);

export default SkipBackButton;
